import { Component, OnInit } from '@angular/core';
import { FormBuilder,FormGroup,Validators } from '@angular/forms';
import { SignupService } from '../services/signup.service'
import { Router } from '@angular/router';

@Component({
  selector: 'app-signupverify',
  templateUrl: './signupverify.component.html',
  styleUrls: ['./signupverify.component.css']
})
export class SignupverifyComponent implements OnInit {

  constructor(private formBuilder : FormBuilder,private Signup : SignupService,private router: Router) { }
  Msg;
  RespMsg;
  form: FormGroup;
  mobile=localStorage.getItem("Mobile");
  ngOnInit() {
 
  this.InitForm();
  }
  InitForm()
  {
    this.form = this.formBuilder.group({
      otp:['', Validators.required]
    });
  }
  onSignupVerify(clientData)
  {
    this.Msg ='Wait';
    //console.log(clientData);
    const formData = new FormData();
    formData.append('Otp', clientData.otp);
    formData.append('UID', localStorage.getItem("UID"));
    this.Signup.SignupVerify(formData).subscribe(
      (res:any) => {
        this.RespMsg =res.msg;
        //console.log(res);
        this.InitForm();
        if(res.code==1){
        this.router.navigate(['/SignupCompany']);
        }
        this.Msg ='';
      }
    );  
  }

}
